import request from '../../../config/Request'

const query = {
    queryList:'api/goods/getdispose',// 查询列表
    dispose:'/api/goods/bydispose', // 处置
    ReportCount:'/api/GoodsDispose/ReportCount',// 查询统计列表
    ExportData:'/api/GoodsDispose/ExportData', //导出excel
    ExportReport:'/api/GoodsDispose/ExportReport', //导出报表
    deletedispose:'/api/goods/deletedispose',// 修改医废数据菜单的删除
    getonedispose:'/api/goods/getonedispose',
    updatedispose:'/api/goods/updatedispose',
    pushdispose:'/api/goods/pushdispose',

    UpdateByOrg:'/api/GoodsDispose/UpdateByOrg',

};

/**
 * 查询
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function queryList(parameter) {
    return request({
        url: query.queryList,
        data: parameter
    })
}
export function dispose(parameter) {
    return request({
        url: query.dispose,
        data: parameter
    })
}
export function ReportCount(parameter) {
    return request({
        url: query.ReportCount,
        data: parameter
    })
}
export function ExportData(parameter) {
    return request({
        url: query.ExportData,
        data: parameter
    })
}
export function ExportReport(parameter) {
    return request({
        url: query.ExportReport,
        data: parameter
    })
}

// deletedispose
export function deletedispose(parameter) {
    return request({
        url: query.deletedispose,
        data: parameter
    })
}
// 
export function getonedispose(parameter) {
    return request({
        url: query.getonedispose,
        data: parameter
    })
}
// 
export function updatedispose(parameter) {
    return request({
        url: query.updatedispose,
        data: parameter
    })
}

export function pushdispose(parameter) {
    return request({
        url: query.pushdispose,
        data: parameter
    })
}
export function UpdateByOrg(parameter) {
    return request({
        url: query.UpdateByOrg,
        data: parameter
    })
}
